import React from 'react'
import { connect } from 'react-redux'
import guideImg from '../../images/recorded/guide.png'
import { storage } from '../../utils'


class ClassroomMenuGuide extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShow: false,
        }
    }
    componentDidMount () {
        const { type } = this.props
        if (type === 'recorded') {
            if (storage.getItem('recorded-page-menu-click-count') >= 1) {
                this.setState({ isShow: false })
            } else {
                this.setState({ isShow: true })
            }
        } else {
            if (storage.getItem('classroom-page-menu-click-count') >= 1) {
                this.setState({ isShow: false })
            } else {
                this.setState({ isShow: true })
            }
        }
        this.countDown()
    }
    countDown () {
        this.timer = setTimeout(() => {
            if (this.state.isShow) {
                this.setState({ isShow: false })
                this.setCache()
            }
        }, 5000)
    }
    componentWillReceiveProps (props) {
        if (!this.props.isShowMenuPopup && props.isShowMenuPopup && this.state.isShow) {
            this.setCache()
            this.setState({ isShow: false })
        }
    }
    setCache () {
        const field = this.props.type === 'recorded' ? 'recorded' : 'classroom'
        if (!storage.getItem(`${field}-page-menu-click-count`)) {
            storage.setItem(`${field}-page-menu-click-count`, 1)
        } else {
            storage.setItem(`${field}-page-menu-click-count`, storage.getItem(`${field}-page-menu-click-count`) + 1)
        }
    }
    render() {
        if (!this.state.isShow || !this.props.channelLectures || this.props.channelLectures.length === 0) {
            return null
        }
        return (
            <div className="guide-wrap classroom-menu-guide">
                <div className={`guide`}>
                    <img src={guideImg} alt=""/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    isShowMenuPopup: state.classroom.isShowMenuPopup,
    channelLectures: state.classroom.channelLectures,
}))(ClassroomMenuGuide)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomMenuGuide.js